import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { cn } from './cn';

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-[var(--radius-sm)] border transition-colors',
      'focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring-brand)] disabled:cursor-not-allowed disabled:opacity-50',
      // ★QA-C 체크표시 안뜸 버그수정: rest 상태 배경/테두리를 inline style 로 주면
      // inline 우선순위가 아래 data-[state=checked] 클래스를 무력화해 체크 시에도 흰 배경이
      // 유지되고 흰 체크 아이콘이 안 보였다. rest/checked 둘 다 클래스로 표현해 상태 토글이 이긴다.
      'border-[var(--content-soft)] bg-[var(--surface-0)]',
      // 단일 accent 시스템: checked = 브랜드 red fill + 흰 체크.
      'data-[state=checked]:border-[var(--accent-default)] data-[state=checked]:bg-[var(--accent-default)]',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center">
      <Check
        className="h-3 w-3"
        style={{ color: 'var(--cta-primary-on)' } as React.CSSProperties}
      />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
